import axios from 'axios';

import toastError from 'utils/toastError';

import headers from '../headers.json';
import { UnauthorizedType } from '../types/UnauthorizedType';

type SuccessType = {
  success: boolean;
  message: string;
  data: {
    dataframe: {
      [x: string]: {
        [x: string]: string | number;
      };
    };
  };
};

type PromiseType =
  | { data: SuccessType; success: boolean }
  | { data: UnauthorizedType; success: boolean }
  | { data: null; success: boolean };

type DataType = {
  dataframe_id: string;
  row_index: string;
};

const POST_REPARAPHRASE = async (data: DataType): Promise<PromiseType> => {
  try {
    const serverUrl = process.env.REACT_APP_SERVER_URL_BACKEND_API;
    if (!serverUrl) throw Error('Backend-URL not defined.');

    const url = `${serverUrl}/generate/reparaphrase`;

    const response = await axios.post<SuccessType | UnauthorizedType>(url, data, {
      headers: {
        ...headers,
      },
      withCredentials: true,
    });

    if (response.data.success) {
      return { success: true, data: response.data };
    }

    if (response.status === 410) {
      toastError(`This resource is no longer editable because it is permanently locked!`);
    } else {
      toastError(`Error while paraphrasing process!`);
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error(error);
    if (axios.isAxiosError(error) && error.status === 410) {
      toastError(`This resource is no longer editable because it is permanently locked!`);
    } else {
      toastError(`Error while paraphrasing process!`);
    }

    return { success: false, data: null };
  }
};

export default POST_REPARAPHRASE;
